import { ArrowLeftOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';
import DrawerComponent from 'components/Drawer';
import { useState } from 'react';
import FarmerGroupLeaderContent from 'screens/stakeholders/components/drawer/FarmerGroupLeaderContent';
import useFGLById from 'screens/stakeholders/hooks/queries/useFGLById';
import { Farmer } from 'types/common';
import FarmerDrawerContent from './FarmerDrawerContent';

type FarmerDrawerProps = {
  data: Farmer;
  isOpen: boolean;
  onClose: () => void;
  showFGLData: boolean;
  setShowFGLData: (show: boolean) => void;
};

const FarmerDrawer = ({
  data,
  showFGLData,
  isOpen,
  onClose,
  setShowFGLData,
}: FarmerDrawerProps) => {
  const { data: fglData, isLoading: isLoadingFGL } = useFGLById(
    data?.cube?.groupLeader?.id,
    showFGLData,
  );

  const [activeKey, setActiveKey] = useState('1');

  return (
    <DrawerComponent
      title={showFGLData ? 'Group Leader details' : 'Farmer Details '}
      open={isOpen}
      onClose={onClose}
      content={
        !showFGLData ? (
          <FarmerDrawerContent
            data={data}
            showFGLData={showFGLData}
            setShowFGLData={setShowFGLData}
          />
        ) : (
          <>
            <Skeleton active loading={isLoadingFGL} avatar />
            {!isLoadingFGL ? (
              <FarmerGroupLeaderContent
                activeKey={activeKey}
                setActiveKey={setActiveKey}
                data={fglData?.data}
              />
            ) : null}
          </>
        )
      }
      closeIcon={showFGLData && <ArrowLeftOutlined />}
    />
  );
};

export default FarmerDrawer;
